import { Fragment } from "react";
import { Grid } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { IToken } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { TokenHistory, CommonTokenPanel } from "../../../../../components/common";
import { LootTokenPanel } from "./loot-token-panel";
import { StyledDescription, StyledImage } from "./styled";

export const LootBoxToken = () => {
  const { data, isLoading, refetch } = useFetchData<IToken>("/loot/tokens");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "loot", "loot.token"]} data={[{}, {}, data.template]} />

      <PageHeader message="pages.loot.token.title" data={data.template} />

      <Grid container>
        <Grid size={{ xs: 12, sm: 9 }}>
          <StyledImage component="img" src={data.template!.imageUrl} alt="Cascadify token image" />
          <StyledDescription>
            <RichTextDisplay data={data.template!.description} />
          </StyledDescription>
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          {data.templateId ? (
            <>
              <CommonTokenPanel token={data} />
              <LootTokenPanel token={data} onRefreshPage={refetch as any} />
            </>
          ) : null}
        </Grid>
      </Grid>

      {data.id ? <TokenHistory token={data} /> : null}
    </Fragment>
  );
};
